/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_5_AInputs */

const en_mk_pricing_faq_5_a = /** @type {(inputs: Mk_Pricing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The Free plan is active the moment you create a workspace: 3 members, 2 divisions, 5 agents and 30 agent tasks a month — enough to prove whether this way of working suits your team.`)
};

const id_mk_pricing_faq_5_a = /** @type {(inputs: Mk_Pricing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa. Paket Gratis aktif begitu Anda membuat workspace: 3 anggota, 2 divisi, 5 agen, dan 30 tugas agen per bulan — cukup untuk membuktikan apakah cara kerjanya cocok dengan tim Anda.`)
};

/**
* | output |
* | --- |
* | "Yes. The Free plan is active the moment you create a workspace: 3 members, 2 divisions, 5 agents and 30 agent tasks a month — enough to prove whether this wa..." |
*
* @param {Mk_Pricing_Faq_5_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_5_a = /** @type {((inputs?: Mk_Pricing_Faq_5_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_5_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_5_a(inputs)
	return en_mk_pricing_faq_5_a(inputs)
});